export default "__VITE_ASSET__Bn$W5q0Z__"